import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { UpdateCustomerUserDto } from '@ansvar-sakerhet/api-client';
import { toast } from '../../../components/Toast';

export function useUpdateUser() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    customerUserId,
    data,
  }: {
    customerUserId: string;
    data: UpdateCustomerUserDto;
  }) => {
    const api = await getApi();
    const res = await api.customerUserUpdate(customerUserId, data);
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success('Användaren har uppdaterats');
    },
    onError: () => toast.error('Något gick fel'),
  });
}
